import { render, staticRenderFns } from "./orderAfterSaleDetail.vue?vue&type=template&id=f258d0f2&scoped=true"
import script from "./orderAfterSaleDetail.vue?vue&type=script&lang=js"
export * from "./orderAfterSaleDetail.vue?vue&type=script&lang=js"
import style0 from "./orderAfterSaleDetail.vue?vue&type=style&index=0&id=f258d0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f258d0f2",
  null
  
)

export default component.exports